/* ==========================================================================
   Product page behaviour
   1. Option selection -> variant, price, availability, add-to-bag label
   2. Add to bag (via TarCart, see cart.js)
   3. Description "typewriter" collapse while the summary card is condensed
   4. Unified scroll: both columns are driven by the page scroll position
   5. Photo dash indicators
   ========================================================================== */
(function () {
  'use strict';
  if (window.TarProductPage) return;
  window.TarProductPage = true;

  var MOBILE = '(max-width: 900px)';
  function isMobile() { return window.matchMedia(MOBILE).matches; }
  function cssPx(name) {
    return parseFloat(getComputedStyle(document.documentElement).getPropertyValue(name)) || 0;
  }

  function init(root) {
    if (!root || root.__tarInit) return;
    root.__tarInit = true;

    var data = JSON.parse(root.querySelector('[data-product-data]').textContent);
    var variants = data.variants;
    var groups = [].slice.call(root.querySelectorAll('[data-option-group]'));
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var btn = root.querySelector('[data-add-to-bag]');
    var label = root.querySelector('[data-add-to-bag-label]');
    var form = idInput ? idInput.form : null;

    /* ---------------- 1. options -> variant ---------------- */
    var selected = groups.map(function (g) {
      var c = g.querySelector('input:checked');
      return c ? c.value : null;
    });
    var variant = null;
    var flashTimer = null;

    function findVariant() {
      if (!groups.length) return variants[0] || null;
      if (selected.some(function (v) { return v === null; })) return null;
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      })[0] || null;
    }

    // price shown before a full selection exists (lowest / first variant price)
    var currentIdle = label.textContent.trim();

    // sold out: quiet "notify me" line (stores the email as a customer with a tag)
    var notify = root.querySelector('[data-notify]');
    var notifyTags = root.querySelector('[data-notify-tags]');

    function updateNotify() {
      if (!notify) return;
      var show = !!(variant && !variant.available);
      notify.hidden = !show;
      if (show && notifyTags) notifyTags.value = 'back-in-stock, bis-' + notify.dataset.handle + '-' + variant.id;
      if (!show) notify.classList.remove('is-open', 'is-done');
    }

    if (notify) {
      var notifyToggle = notify.querySelector('[data-notify-toggle]');
      var notifyForm = notify.querySelector('form');
      var notifyThanks = notify.querySelector('.notify__thanks');
      notifyToggle.addEventListener('click', function () {
        var open = notify.classList.toggle('is-open');
        notifyToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) notifyForm.querySelector('input[type="email"]').focus();
      });
      notifyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        fetch(notifyForm.action, { method: 'POST', body: new FormData(notifyForm) }).then(function (res) {
          if (!res.ok || res.url.indexOf('/challenge') > -1) { notifyForm.submit(); return; }
          notify.classList.add('is-done');
          notifyThanks.hidden = false;
        }).catch(function () { notifyForm.submit(); });
      });
    }

    function updateAvailability() {
      groups.forEach(function (group, gi) {
        [].slice.call(group.querySelectorAll('.option')).forEach(function (opt) {
          var val = opt.querySelector('input').value;
          var anyAvailable = variants.some(function (v) {
            if (v.options[gi] !== val) return false;
            return selected.every(function (s, si) {
              return si === gi || s === null || v.options[si] === s;
            }) && v.available;
          });
          opt.classList.toggle('is-unavailable', !anyAvailable);
        });
      });
    }

    function update() {
      variant = findVariant();

      groups.forEach(function (group) {
        [].slice.call(group.querySelectorAll('.option')).forEach(function (opt) {
          opt.classList.toggle('selected', opt.querySelector('input').checked);
        });
      });
      updateAvailability();
      updateNotify();

      if (variant) {
        if (idInput) idInput.value = variant.id;
        if (priceEl) {
          priceEl.innerHTML = (variant.compare_at_formatted ? '<s>' + variant.compare_at_formatted + '</s>' : '') + variant.price_formatted;
        }
        currentIdle = variant.available
          ? btn.dataset.labelAdd.replace('__price__', variant.price_formatted)
          : btn.dataset.labelSoldOut;
        btn.disabled = !variant.available;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } else {
        var allChosen = groups.length && selected.every(function (v) { return v !== null; });
        btn.disabled = !!allChosen;
        if (allChosen) currentIdle = btn.dataset.labelUnavailable;
      }
      if (!flashTimer) label.textContent = currentIdle;
    }

    groups.forEach(function (group, gi) {
      group.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'radio') {
          selected[gi] = e.target.value;
          update();
        }
      });
    });

    function flash(text, ms) {
      if (flashTimer) clearTimeout(flashTimer);
      label.textContent = text;
      flashTimer = setTimeout(function () {
        flashTimer = null;
        label.textContent = currentIdle;
      }, ms);
    }

    /* ---------------- 2. add to bag ---------------- */
    if (form) {
      form.addEventListener('submit', function (e) { e.preventDefault(); });
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!variant) {
        var missing = selected.indexOf(null);
        if (missing > -1) {
          flash(btn.dataset.labelSelect.replace('__option__', groups[missing].dataset.optionName.toLowerCase()), 1400);
        }
        return;
      }
      if (!variant.available || !window.TarCart) return;
      btn.disabled = true;
      window.TarCart.add(variant.id, 1).then(function () {
        flash(btn.dataset.labelAdded, 1400);
        window.TarCart.open();
      }).catch(function (err) {
        flash(err && err.message ? err.message : btn.dataset.labelError, 2400);
      }).then(function () {
        btn.disabled = !(variant && variant.available);
      });
    });

    update();

    /* ---------------- 3. description collapse ---------------- */
    var summary = root.querySelector('[data-sticky-summary]');
    var desc = root.querySelector('[data-desc]');
    var descFull = desc ? desc.textContent.trim() : '';
    var descLen = descFull.length;
    var descBaseMargin = cssPx('--gap-base') || 20;
    var descRAF = null;

    function paintDesc(n) {
      if (!desc) return;
      desc.textContent = descFull.slice(0, n);
      desc.style.marginTop = (descBaseMargin * (n / descFull.length)) + 'px';
    }
    function animateDesc(collapse) {
      if (!desc) return;
      if (descRAF) cancelAnimationFrame(descRAF);
      var startLen = descLen;
      var targetLen = collapse ? 0 : descFull.length;
      if (startLen === targetLen) return;
      var duration = 380;
      var t0 = performance.now();
      function step(now) {
        var t = Math.min(1, (now - t0) / duration);
        var eased = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
        descLen = Math.round(startLen + (targetLen - startLen) * eased);
        paintDesc(descLen);
        if (t < 1) { descRAF = requestAnimationFrame(step); } else { descRAF = null; }
      }
      descRAF = requestAnimationFrame(step);
    }

    /* ---------------- 4. unified scroll ---------------- */
    var infoZone = root.querySelector('[data-info-zone]');
    var infoScroll = root.querySelector('[data-info-scroll]');
    var photoZone = root.querySelector('[data-photo-zone]');
    var photoScroll = root.querySelector('[data-photo-scroll]');
    var dots = [].slice.call(root.querySelectorAll('[data-photo-dot]'));

    var extraScrollInfo = 0;
    var extraScrollPhoto = 0;
    var masterExtra = 0;
    var wasCondensed = false;

    function stickyTop() {
      var headerH = cssPx('--header-h');
      return isMobile() ? headerH : headerH + cssPx('--header-gap');
    }

    // height of the summary card in its condensed state (no description)
    function measureCondensedCardHeight() {
      var was = summary.classList.contains('is-condensed');
      var prevText = desc ? desc.textContent : '';
      var prevMargin = desc ? desc.style.marginTop : '';

      summary.classList.add('measuring');
      if (!was) summary.classList.add('is-condensed');
      if (desc) { desc.textContent = ''; desc.style.marginTop = '0px'; }
      void summary.offsetHeight;
      var h = summary.getBoundingClientRect().height;
      if (!was) summary.classList.remove('is-condensed');
      if (desc) { desc.textContent = prevText; desc.style.marginTop = prevMargin; }
      summary.classList.remove('measuring');
      return h;
    }

    function layout() {
      var top = stickyTop();
      var H = window.innerHeight;
      var cardH = measureCondensedCardHeight();
      extraScrollInfo = Math.max(0, cardH + infoScroll.scrollHeight - (H - top));
      extraScrollPhoto = Math.max(0, photoScroll.scrollHeight - H);
      masterExtra = Math.max(extraScrollInfo, extraScrollPhoto);

      var zoneHeight = H + masterExtra;
      infoZone.style.height = zoneHeight + 'px';
      photoZone.style.height = zoneHeight + 'px';

      onScroll();
      updateDotsMobile();
    }

    function onScroll() {
      var zoneTop = infoZone.getBoundingClientRect().top;
      var raw = Math.min(Math.max(-zoneTop, 0), masterExtra);
      var fraction = masterExtra > 0 ? raw / masterExtra : 0;

      var infoProgress = fraction * extraScrollInfo;
      var photoProgress = fraction * extraScrollPhoto;
      infoScroll.style.transform = 'translateY(-' + infoProgress + 'px)';
      photoScroll.style.transform = 'translateY(-' + photoProgress + 'px)';

      var condensed = infoProgress > 2;
      if (condensed !== wasCondensed) {
        wasCondensed = condensed;
        summary.classList.toggle('is-condensed', condensed);
        animateDesc(condensed);
      }
      updateDots(fraction);
    }

    /* ---------------- 5. photo dashes ---------------- */
    function setActiveDot(idx) {
      dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
    }
    function updateDots(fraction) {
      if (!dots.length || isMobile()) return;
      setActiveDot(Math.round(fraction * (dots.length - 1)));
    }
    function updateDotsMobile() {
      if (!dots.length || !isMobile()) return;
      var w = photoScroll.getBoundingClientRect().width || 1;
      setActiveDot(Math.round(photoScroll.scrollLeft / w));
    }
    photoScroll.addEventListener('scroll', updateDotsMobile, { passive: true });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', layout);
    window.addEventListener('load', layout);
    if (window.ResizeObserver) {
      var raf = null;
      var ro = new ResizeObserver(function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(layout);
      });
      ro.observe(photoScroll);
      ro.observe(infoScroll);
      ro.observe(summary);
    }
    layout();
  }

  function initAll() {
    [].slice.call(document.querySelectorAll('[data-product-section]')).forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
